import { render, staticRenderFns } from "./platformIntroduction.vue?vue&type=template&id=b53b21e0&scoped=true&"
import script from "./platformIntroduction.vue?vue&type=script&lang=js&"
export * from "./platformIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./platformIntroduction.vue?vue&type=style&index=0&id=b53b21e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53b21e0",
  null
  
)

export default component.exports